
import { ViewUtil } from '../../utils/view.js';

const commonMixin = {
    data() {
        return {
            isDev: true,
            PageStore: PageStore,

            // Views
            // isNavOpen: false,
            popovers: {
                // confirmDelete: false,
                // selectShippingMethod: false,
            },
            watchLock: false,
            dataLoaded: false,
            lock: false,
            
            // For Project
            // emailAddrHref: 'mailto:' + 'furuno' + '@' + "yhashimoto.com" + '?subject=' + 'ウェブサイトよりお問合せ',
            // emailAddr: 'f&#117;&#114;un&#111;&#64;&#112;&#111;&#115;&#115;&#105;&#45;h&#97;t&#111;&#121;&#97;&#109;&#97;.&#99;om',
        };
    },
    watch: {

    },
    computed: {

    },
    methods: {
        onOpenPopover(id, obj = {}) {
            this.popovers[id] = true;
        },
        onClosePopover(id) {
            this.popovers[id] = false;
        },
        // toggleNav() {
        //     console.log(this.isNavOpen);
        //     this.isNavOpen = !this.isNavOpen;
        // },
//         onMoveAndClose(target) {
//             // #mainにスクロール
//             let mainElement = document.getElementById(target);
//             if (mainElement) {
//                 mainElement.scrollIntoView({ behavior: 'smooth' });
//             }
// 
//             // ナビゲーションを閉じる
//             this.isNavOpen = false;
//         },
        // calcEmailAddr(emailAddr) {
        //     return ViewUtil.mailConverter(emailAddr);
        // },
        debugVars() {
           // console.log('-------------------------------------');
            //console.log('shippingCountryId: ', this.shippingCountryId);
            //console.log('-------------------------------------');
        }
    },
    async mounted() {
        setTimeout(() => {
            this.debugVars();
        }, 100);

        this.dataLoaded = true;
        // nextTick(() => {
        //     this.dataLoaded = true;
        // })

        //console.log(this.ExchangeRates.rates);
    }
};

export default commonMixin;